import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=e836f5fc&scoped=true"
import script from "./StudentInformation.vue?vue&type=script&lang=js"
export * from "./StudentInformation.vue?vue&type=script&lang=js"
import style0 from "./StudentInformation.vue?vue&type=style&index=0&id=e836f5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e836f5fc",
  null
  
)

export default component.exports